import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonSlide, IonFooter } from '@ionic/react';

//import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function DeleteRequisitionModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewRequisitionList, setViewRequisitionList] = useState([]);
    let [requisitionID, setRequisitionID] = useState(null);

    let requisitionNameRef = useRef(null);


    function deleteRequisition(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74599);
        formData.append('user', acctID);
        formData.append('xrequisitionID', requisitionID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74599',
                user: acctID,
                xRequisitionID: requisitionID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

   
    function searchRequisitionList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchRequisitionInDB(searchCategory, searchData);


    }

    function first_searchRequisitionInDB(searchCategory, searchData, optionsData)
    {
        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {

            Tracker = '74502';
        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xsearchRequisition: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);
                    

                                    setViewRequisitionList((prevViewRequisitionList) => {
                                        return prevViewRequisitionList.concat({
                                            requisitionID: cols[0],
                                            companyRole: cols[1],
                                            requisitionName: cols[2],
                                            requisitionResponsibilites: cols[3],
                                            requisitionQualifications: cols[4],
                                            requisitionDeadline: cols[5],
                                            dateCreated: cols[6],
                                            numApplicationsRecieved: cols[7],
                        
                                        })
                                    });
                    
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }

                                if(cols[10] === 'y')
                                {
                                    document.getElementById('inventoryAccess').checked = true;
                                }
                                if(cols[11] === 'y')
                                {
                                    document.getElementById('requisitionManagementAccess').checked = true;
                                }
                                if(cols[12] === 'y')
                                {
                                    document.getElementById('checkInCheckOutAccess').checked = true;
                                }        
                                if(cols[13] === 'y')
                                {
                                    document.getElementById('cleaningServicesAccess').checked = true;
                                }
                            }
                    })
    }

    
let timeout;

function handleInput(event) {

    setViewRequisitionList([]);

    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchRequisitionList(event), 2000); // Set a new timeout

}

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonText className='professional-input'>DELETE REQUISITION</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
            <IonContent className='grid_content'>

                <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <h4>Search Requisitions:</h4>
                            </IonCol>
                            <IonCol size='12'>
                                <input type='text' id='searchRequisition' ref={ requisitionNameRef } placeholder='Search requisition name' onInput={() => handleInput(['name', requisitionNameRef.current.value])} list='searchRequisitionNameList' autocomplete='off' required></input>
                                <datalist id='searchRequisitionNameList'>
                                    {viewRequisitionList.map((result) => (
                                        <option key={result.requisitionID} value={result.requisitionFirstName}></option>
                                    ))}
                                </datalist>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                <div id='deleteRequisitionGrid' style={{display: 'inline-block'}}>
                <IonGrid >
                    <IonRow >
                            <IonCol >ID</IonCol>
                            <IonCol >Name</IonCol>
                            <IonCol >Action</IonCol>
                    </IonRow>
                    {viewRequisitionList.map((detailData) =>   {
                        return (
                            <IonRow class='gridResultBody'>
                                <IonCol >{detailData.requisitionID}</IonCol>
                                <IonCol >{detailData.requisitionFirstName + ' '+detailData.requisitionLastName }</IonCol>
                                <IonCol >
                                    <IonButton class='gridResultColumnButton' > xxx </IonButton>
                                    <IonButton class='gridResultColumnButton' > xxx </IonButton>
                                </IonCol>
                            </IonRow>
                        )
                    }
                    )}
                </IonGrid>
                </div>
                <IonFooter className='Modal_Footer'>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => deleteRequisition()}> Delete</IonButton>
                            </IonCol>
                            <IonCol>
                                <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>
        </IonContent>
        </IonModal>) : null}
    </React.Fragment>
    )
}